// Native display names, keyed by 2-letter code.
export const LANGUAGE_LABELS: Record<string, string> = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  ar: 'عربى',
  ur: 'اردو',
  pl: 'Polskie',
  tl: 'Tagalog',
  vi: 'Tiếng Việt',
  yo: 'Yoruba',
  zh: '简体中文',
  sw: 'kiswahili',
  so: 'Soomaali',
  ru: 'Русский',
  pt: 'Português',
  my: 'မြန်မာ (ဗမာ)',
  hi: 'हिन्दी',
  np: 'नेपाली',
  ht: 'Kreyòl ayisyen',
};

// Codes where Google's combo differs from ours; default to identity.
const GOOGLE_CODE_OVERRIDES: Record<string, string> = {
  zh: 'zh-CN',
};

export const toGoogleCode = (lang: string): string => GOOGLE_CODE_OVERRIDES[lang] || lang;

const FROM_GOOGLE_CODE: Record<string, string> = Object.fromEntries(
  Object.entries(GOOGLE_CODE_OVERRIDES).map(([lang, google]) => [google, lang]),
);

export const fromGoogleCode = (google: string): string => FROM_GOOGLE_CODE[google] || google;
